import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const current = testimonials[active];

  return (
    <section className="bg-[#f0f9f9] py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#9a9a9a] text-xs font-medium tracking-widest uppercase mb-3">Client Stories</p>
          <h2 className="text-3xl md:text-4xl font-light text-[#2d2d2d]" style={{ fontFamily: "'Playfair Display', serif" }}>
            Real People, <span className="italic font-semibold">Real Change.</span>
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="relative bg-[#418b86] rounded-3xl overflow-hidden min-h-[340px] flex flex-col lg:flex-row">
          {/* Left: Image */}
          <div className="relative lg:w-72 flex-shrink-0 h-64 lg:h-auto overflow-hidden">
            <img
              src={current.image}
              alt={current.name}
              className="w-full h-full object-cover object-top transition-all duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#418b86]/30 hidden lg:block"></div>
          </div>

          {/* Right: Content */}
          <div className="flex-1 p-8 md:p-12 flex flex-col justify-center">
            {/* Quote mark */}
            <div className="text-[#7ec8e3]/30 text-8xl font-serif leading-none mb-2 -mt-4" style={{ fontFamily: "'Playfair Display', serif" }}>"</div>
            <p className="text-white text-lg md:text-xl font-light leading-relaxed mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
              {current.quote}
            </p>
            <div>
              <p className="text-white font-medium text-sm">{current.name}</p>
              <p className="text-white/50 text-xs mt-0.5">{current.descriptor}</p>
            </div>
          </div>

          {/* Navigation Dots */}
          <div className="absolute bottom-6 right-8 flex items-center gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`rounded-full transition-all duration-200 cursor-pointer ${
                  i === active ? "w-6 h-2 bg-[#7ec8e3]" : "w-2 h-2 bg-white/30 hover:bg-white/50"
                }`}
                aria-label={`Testimonial ${i + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Navigation Arrows */}
        <div className="flex items-center justify-center gap-4 mt-8">
          <button
            onClick={() => setActive((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-[#c8e8e6] text-[#6b6b6b] hover:border-[#4db8b1] hover:text-[#418b86] transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
          </button>
          <span className="text-[#9a9a9a] text-sm">{active + 1} / {testimonials.length}</span>
          <button
            onClick={() => setActive((prev) => (prev + 1) % testimonials.length)}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-[#c8e8e6] text-[#6b6b6b] hover:border-[#4db8b1] hover:text-[#418b86] transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
